

/*
FrFr FRIENDLY FRAMEWORK
frfr-virbom-counter-utils
Version ID: 1a 2023-05-14r1
by 
// Please describe here if you customized this file
*/


let virbomCounter_state = 0;

export const virbomCounter = {};

virbomCounter.generateFreshSubkey = (n) => {
  virbomCounter_state++;
  if (n > virbomCounter_state || n === virbomCounter_state) {
    // osigurava da caounter uvek generise veci broj od maksimalnog prethodno upotrebljenog
    virbomCounter_state = n + 1;
  }
  return virbomCounter_state;
};

virbomCounter.updateSmart = (n) => {
  // 
  if (n > virbomCounter_state || n === virbomCounter_state) {
    // osigurava da caounter uvek generise veci broj od maksimalnog prethodno upotrebljenog
    virbomCounter_state = n + 1;
  }
  return true;
};

virbomCounter.resetCounter = () => {
  virbomCounter_state = 0; // resetuje counter da ponovo pocne od 0
  return true;
};

// export default virbomCounter;